import React from "react";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Box from "@amzn/meridian/box";
import { Space } from "../../../../space/Space";
import { TableProps } from "./types";

export const ValueTable: React.FC<TableProps> = ({ title, headers, rows }) => {
    return (
        <Box>
            <Space size="s" />
            <Row alignmentHorizontal="start">
                <Text type="h400">{title}</Text>
            </Row>
            <Space size="s" />
            <Table headerRows={1} showDividers={true}>
                <TableRow>
                    {headers.map((header, index) => (
                        <TableCell key={index}>{header}</TableCell>
                    ))}
                </TableRow>
                {rows.map((row, rowIndex) => (
                    <TableRow
                        key={rowIndex}
                        backgroundColor={rowIndex % 2 === 1 ? "secondary" : undefined}
                        highlightOnHover={true}
                    >
                        {row.map((cell, cellIndex) => (
                            <TableCell key={cellIndex}>
                                {cellIndex === 0 && rowIndex === rows.length - 1 ? (
                                    <b>{cell}</b>
                                ) : (
                                    cell
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </Table>
            <Space size="s" />
        </Box>
    );
};
